import React, { useEffect, useMemo, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Tab, Tabs, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStoreActions, useStoreState } from "easy-peasy";
import api from "../../services/api";
import { tiposCargas, tiposServicos } from "../../static";
import ListTomadaPreco from "./ListTomadaPreco";
import ListTomadaPreco2fase from "./ListTomadaPreco2fase";

const labelDesconhecido = (id) => id.replace(/_/g, " ").toUpperCase();

const AcompanhaOrcamentosDinamico = ({ fase }) => {
  const currProcesso = useStoreState((state) => state.processo.current);
  const startLoading = useStoreActions((actions) => actions.nav.startLoading);
  const stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [expanded, setExpanded] = useState(false);
  const [solicitadas, setSolicitadas] = useState([]);
  const [selecionada, setSelecionada] = useState(null);
  const estagio = fase === 1 ? "tomada" : "orcamento";

  useEffect(() => {
    startLoading();
    api.http.get(`/orcamentos/processo/tomada/tecnologia/${currProcesso.id}/${estagio}/`)
      .then(({ data }) => {
        setSolicitadas(data);
        stopLoading();
      })
      .catch((error) => stopLoading({ message: error.toString(), severity: "error" }));
  }, [currProcesso.id, estagio, startLoading, stopLoading]);

  const grupos = useMemo(() => {
    const ids = [...new Set(solicitadas.map((item) => item.tipo_carga))];
    const servicosIds = new Set(tiposServicos.map(({ id }) => id));
    const labels = new Map([...tiposCargas, ...tiposServicos].map(({ id, label }) => [id, label]));
    const montar = (lista) => lista.map((id) => ({ id, label: labels.get(id) || labelDesconhecido(id) }));
    return {
      tecnologias: montar(ids.filter((id) => id !== "esco" && !servicosIds.has(id))),
      servicos: montar(ids.filter((id) => servicosIds.has(id))),
      esco: ids.includes("esco") ? [{ id: "esco", label: "PROPOSTA UNIFICADA" }] : [],
    };
  }, [solicitadas]);

  const renderGrupo = (id, titulo, itens) => itens.length > 0 && (
    <Accordion expanded={expanded === id} onChange={(_, aberto) => setExpanded(aberto ? id : false)} sx={{ boxShadow: "none", borderBottom: 1, borderColor: "divider" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight="bold" fontSize="1rem" color="text.secondary">{titulo}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ maxHeight: 300, overflowY: "auto" }}>
        <Tabs orientation="vertical" variant="scrollable" value={false}>
          {itens.map((item) => <Tab key={item.id} label={item.label} onClick={() => setSelecionada(item.id)} />)}
        </Tabs>
      </AccordionDetails>
    </Accordion>
  );

  const Lista = fase === 1 ? ListTomadaPreco : ListTomadaPreco2fase;
  return (
    <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex", height: "100vh" }}>
      <Box sx={{ width: "15%", borderRight: 1, borderColor: "divider", display: "flex", flexDirection: "column" }}>
        {renderGrupo("tecnologias", "TECNOLOGIAS", grupos.tecnologias)}
        {renderGrupo("servicos", "SERVIÇOS", grupos.servicos)}
        {renderGrupo("esco", "ESCO", grupos.esco)}
      </Box>
      <Box sx={{ width: "85%" }}>
        {selecionada && <Lista key={selecionada} currProcesso={currProcesso} tipoCarga={selecionada} />}
      </Box>
    </Box>
  );
};

export default AcompanhaOrcamentosDinamico;
